var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowcounterclockwise28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87343 8.50003C7.26107 7.99892 7.70838 7.53079 8.21498 7.1057C12.0227 3.91068 17.6995 4.40734 20.8945 8.21501C24.0895 12.0227 23.5928 17.6995 19.7852 20.8945C15.9775 24.0895 10.3007 23.5929 7.10567 19.7852C6.57317 19.1506 5.62704 19.0678 4.99243 19.6003C4.35781 20.1328 4.27504 21.0789 4.80754 21.7135C9.06756 26.7904 16.6366 27.4527 21.7135 23.1926C26.7904 18.9326 27.4526 11.3635 23.1926 6.28664C18.9326 1.20975 11.3635 0.547542 6.28662 4.80756C5.74006 5.26618 5.24421 5.76375 4.79999 6.29291V4.00003C4.79999 3.1716 4.12841 2.50003 3.29999 2.50003C2.47156 2.50003 1.79999 3.1716 1.79999 4.00003V10C1.79999 10.8285 2.47156 11.5 3.29999 11.5H9.29999C10.1284 11.5 10.8 10.8285 10.8 10C10.8 9.1716 10.1284 8.50003 9.29999 8.50003H6.87343Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowcounterclockwise28);
export default __webpack_public_path__ + "static/media/arrow.counterclockwise_28.b12a343a.svg";
export { ForwardRef as ReactComponent };